import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';

/**
 * Gate for the `/app` workspace — a UX check that a session exists. Real authorisation (and
 * per-role access) is enforced server-side on every API call; a 401 there bounces to login via the
 * auth interceptor.
 */
export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.isAuthenticated()) return true;
  router.navigate(['/auth/login']);
  return false;
};
